import React, { useState, useEffect } from "react";
import openSocket from "../../services/socket-io";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";

import api from "../../services/api";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(8, 8, 3),
	},

	paper: {
		padding: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		marginBottom: 12,

	},

	settingOption: {
		marginLeft: "auto",
	},
	margin: {
		margin: theme.spacing(1),
	},

}));

const Settings = () => {
	const classes = useStyles();

	const [settings, setSettings] = useState([]);

	useEffect(() => {
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/settings");
				setSettings(data);
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		const socket = openSocket();

		socket.on("settings", data => {
			if (data.action === "update") {
				setSettings(prevState => {
					const aux = [...prevState];
					const settingIndex = aux.findIndex(s => s.key === data.setting.key);
					if (settingIndex !== -1) {
						aux[settingIndex].value = data.setting.value;
					} else {
						aux.push(data.setting);
					}
					return aux;
				});
			}
		});

		return () => {
			socket.disconnect();
		};
	}, []);

	const handleChangeSetting = async e => {
		const selectedValue = e.target.value;
		const settingKey = e.target.name;

		try {
			await api.put(`/settings/${settingKey}`, {
				value: selectedValue,
			});
			toast.success(i18n.t("settings.success"));
		} catch (err) {
			toastError(err);
		}
	};

	const handleTextFieldChange = async (key, value) => {
		try {
			await api.put(`/settings/${key}`, {
				value: value,
			});
			toast.success(i18n.t("settings.success"));
		} catch (err) {
			toastError(err);
		}
	};

	const getSettingValue = key => {
		const setting = settings.find(s => s.key === key);
		if (!setting) return undefined;
		return setting.value;
	};

	const renderSelectSetting = (key, label, options) => {
		const value = getSettingValue(key);
		if (value === undefined) return null;
		
		return (
			<Paper className={classes.paper} key={key}>
				<Typography variant="body1">
					{label}
				</Typography>
				<Select
					margin="dense"
					variant="outlined"
					native
					id={`${key}-setting`}
					name={key}
					value={value || ""}
					className={classes.settingOption}
					onChange={handleChangeSetting}
				>
					{options.map(opt => (
						<option key={opt.value} value={opt.value}>
							{opt.label}
						</option>
					))}
				</Select>
			</Paper>
		);
	};

	const renderTextFieldSetting = (key, label, readonly = false) => {
		const value = getSettingValue(key);
		if (value === undefined) return null;
		
		return (
			<Paper className={classes.paper} key={key}>
				<TextField
					id={`${key}-setting`}
					label={label}
					margin="dense"
					variant="outlined"
					fullWidth
					readOnly={readonly}
					value={value || ""}
					onChange={readonly ? undefined : (e) => {
						handleChangeSetting({
							target: { name: key, value: e.target.value }
						});
					}}
				/>
			</Paper>
		);
	};

	return (
		<div className={classes.root}>
			<Container className={classes.container} maxWidth="sm">
				<Typography variant="body2" gutterBottom>
					{i18n.t("settings.title")}
				</Typography>
				
				{/* Criação de Usuário */}
				{renderSelectSetting("userCreation", "Criação de usuário", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Token API */}
				{renderTextFieldSetting("userApiToken", "Token API", true)}

				{/* Verificar se mensagem é grupo */}
				{renderSelectSetting("CheckMsgIsGroup", "Verificar mensagem de grupo", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Chamadas */}
				{renderSelectSetting("call", "Chamadas", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Tipo de ChatBot */}
				{renderSelectSetting("chatBotType", "Tipo de ChatBot", [
					{ value: "text", label: "Texto" },
					{ value: "button", label: "Botão" }
				])}

				{/* Tipo de Agendamento */}
				{renderSelectSetting("scheduleType", "Tipo de Agendamento", [
					{ value: "queue", label: "Fila" },
					{ value: "user", label: "Usuário" }
				])}

				{/* Enviar mensagem de boas-vindas ao aceitar */}
				{renderSelectSetting("sendGreetingAccepted", "Enviar mensagem de boas-vindas ao aceitar", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Enviar mensagem ao transferir ticket */}
				{renderSelectSetting("sendMsgTransfTicket", "Enviar mensagem ao transferir ticket", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Avaliação do usuário */}
				{renderSelectSetting("userRating", "Avaliação do usuário", [
					{ value: "enabled", label: "Ativado" },
					{ value: "disabled", label: "Desativado" }
				])}

				{/* Integrações - Asaas */}
				{getSettingValue("asaas") !== undefined && (
					<Paper className={classes.paper} key="asaas">
						<TextField
							id="asaas-setting"
							label="Token Asaas"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("asaas") || ""}
							onChange={(e) => handleTextFieldChange("asaas", e.target.value)}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("asaas")) {
									handleTextFieldChange("asaas", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

				{/* Integrações - IPMKAUTH */}
				{getSettingValue("ipmkauth") !== undefined && (
					<Paper className={classes.paper} key="ipmkauth">
						<TextField
							id="ipmkauth-setting"
							label="IP MKAUTH"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("ipmkauth") || ""}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("ipmkauth")) {
									handleTextFieldChange("ipmkauth", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

				{/* Integrações - Client ID MKAUTH */}
				{getSettingValue("clientidmkauth") !== undefined && (
					<Paper className={classes.paper} key="clientidmkauth">
						<TextField
							id="clientidmkauth-setting"
							label="Client ID MKAUTH"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("clientidmkauth") || ""}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("clientidmkauth")) {
									handleTextFieldChange("clientidmkauth", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

				{/* Integrações - Client Secret MKAUTH */}
				{getSettingValue("clientsecretmkauth") !== undefined && (
					<Paper className={classes.paper} key="clientsecretmkauth">
						<TextField
							id="clientsecretmkauth-setting"
							label="Client Secret MKAUTH"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("clientsecretmkauth") || ""}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("clientsecretmkauth")) {
									handleTextFieldChange("clientsecretmkauth", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

				{/* Integrações - IPIXC */}
				{getSettingValue("ipixc") !== undefined && (
					<Paper className={classes.paper} key="ipixc">
						<TextField
							id="ipixc-setting"
							label="IP IXC"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("ipixc") || ""}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("ipixc")) {
									handleTextFieldChange("ipixc", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

				{/* Integrações - Token IXC */}
				{getSettingValue("tokenixc") !== undefined && (
					<Paper className={classes.paper} key="tokenixc">
						<TextField
							id="tokenixc-setting"
							label="Token IXC"
							margin="dense"
							variant="outlined"
							fullWidth
							value={getSettingValue("tokenixc") || ""}
							onBlur={(e) => {
								if (e.target.value !== getSettingValue("tokenixc")) {
									handleTextFieldChange("tokenixc", e.target.value);
								}
							}}
						/>
					</Paper>
				)}

			</Container>
		</div>
	);
};

export default Settings;
